import React, { useState, useEffect, useRef, useContext } from "react";
import "./RepairOrders.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFile } from "@fortawesome/free-solid-svg-icons";
import ActiveTaskCard from "./ActiveTaskCard";
import OthersTaskCard from "./OthersTaskCard";
import dashboardApi from "../../services/dashboardApi";
import masterApi from "../../services/masterApi";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";
import StatusImg from "../../assets/images/teardown-icon-black.png";

const BASE_URL = process.env.REACT_APP_API_URL;

const RepairOrders = ({
  hideRoList,
  dismissPopup,
  //numberOfitems,
  triggerStatusBarReload,
}) => {
  const [file, setFile] = useState(null);
  const [userId, setUserId] = useState(null);

  const fileInputRef = useRef(null);
  const [validData, setValidData] = useState([]);
  const [filteredValidData, setFilteredValidData] = useState([]);
  const [invalidData, setInValidData] = useState([]);
  const [stages, setStage] = useState([]);
  const [filteredStage, setFilteredStage] = useState('all');

  const { isROReload } = useContext(AuthContext);
  const handleSearchClick = () => {
    console.log("Search icon clicked");
  };

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    const fileType = selectedFile.type;
    const validFileTypes = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    if (!validFileTypes.includes(fileType)) {
      toast.error("Please upload a valid Excel file (.xls or .xlsx).");
      return;
    }
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("userId", userId);
      try {
        const response = await dashboardApi.uploadFile({ formData });
        if (response.ok) {
          toast.success(response.message);
          await fetchData();
        } else {
          toast.error(response.message);
        }
      } catch (err) {
      } finally {
        e.target.value = null;
      }
    }
  };

  const [selectedTab, setSelectedTab] = useState("active-tab");
  const dragStarted = (darg) => {
    hideRoList();
  };
  const fetchData = async () => {
    try {
      const stageResponse = await masterApi.getActiveStages()      
      let stageList=stageResponse?.data?.stageList;

      setStage(stageList); 

      const response = await dashboardApi.getRepairOrdersForToday();
      /*if (response?.data?.repairorderList) {
        numberOfitems(response?.data?.repairorderList.length);
      }*/
      let activeTabData = response?.data?.repairorderList
        ?.filter(item => item?.partsReceivedPercentage > 0) // Filter items with partsReceivedPercentage > 0
        .map(item => ({
          repairOrderId: item._id,
          roNumber: item.roNumber,
          customerName: item.customerName,
          ROHours: item.roHours,
          Technician: 'Technician',
          taskName: item.customerName,
          createdAt: item.createdAt,
          status: item.roStatus,
          partsReceivedPercentage: item.partsReceivedPercentage,
          utilizedTaskDuration: item.utilizedTaskDuration,
          remainingROHours: item.remainingROHours,
          roItemStatus: item.roItemStatus,
          stageDetails:item.stageDetails,
        }));
      setValidData(activeTabData);  
      setFilteredValidData(activeTabData);  
      let othersTabData = response?.data?.repairorderList
        ?.filter(item => item?.partsReceivedPercentage <= 0) // Filter items with partsReceivedPercentage > 0
        .map(item => ({
          repairOrderId: item._id,
          roNumber: item.roNumber,
          customerName: item.customerName,
          ROHours: item.roHours,
          Technician: 'Technician',
          taskName: item.customerName,
          createdAt: item.createdAt,
          status: item.roStatus,
          partsReceivedPercentage: item.partsReceivedPercentage,
          utilizedTaskDuration: item.utilizedTaskDuration,
          remainingROHours: item.remainingROHours,
          roItemStatus: item.roItemStatus,
          stageDetails:item.stageDetails
        }));
        setInValidData(othersTabData);
      triggerStatusBarReload();    
    } catch (error) {
    } finally {
    }
  };
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        const parsedUserData = JSON.parse(user);
        setUserId(parsedUserData._id);
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
    fetchData();
  }, [isROReload]);

  const filterByState = (stageId) => {
    if(stageId==='all') {
      setFilteredStage('all');
      setFilteredValidData(validData);
    } else if(stageId){                             //.tags.some(tag => tag.name === tagName)
      const filteredStageData = validData.filter(item => item?.stageDetails?.some(item => item.roStageId === stageId));
      setFilteredStage(stageId);
      setFilteredValidData(filteredStageData);
    }
    else {
      setFilteredStage('all');
      setFilteredValidData(validData);
    }
  };

  return (
    <div className="repair-orders">
      {selectedTab === "active-tab" && (
        <div className="active-tasks">
          <div className="task-icons">
            {/*<FontAwesomeIcon
              icon={faSearch}
              className="icon"
              onClick={handleSearchClick}
              style={{ cursor: "pointer" }}
            />*/}
          <FontAwesomeIcon
            icon={faFile}
            className="icon"
            onClick={handleFileClick}
            style={{ cursor: "pointer" }}
          />
          <input
            type="file"
            ref={fileInputRef}
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
        </div>

        <div className="ro-filter">
          <ul>
            <li className={filteredStage === 'all' ? 'active' : ''}  onClick={() => filterByState('all')}>All</li>
            {stages?.map((stageItem) => (                               
                              <li key={stageItem?._id} className={filteredStage === stageItem?._id ? 'toolTip active' : 'toolTip'} onClick={() => filterByState(stageItem?._id)}>
                              <div
                                className="stage-img"
                                style={{
                                  maskImage: `url(${BASE_URL + stageItem?.stageImagePath})`,
                                }}
                              ></div>
                              <span>{stageItem?.roStageName}</span>
                            </li>
                ))}
          </ul>
        </div>

        {filteredValidData.length === 0 ? 
          (
            <p className="nodata">{process.env.REACT_APP_NO_REPAIRORDER_MESSAGE}</p>
          ) 
          : 
          (
            filteredValidData.map((task, index) => (
              <ActiveTaskCard
                key={index}
                task={task}
                index={index}
                whenDragging={dragStarted}
                whenDragEnd={dismissPopup}
                reloadData={fetchData}
              />
            ))
          )
        }
      </div>
      )}
      {selectedTab === "others-tab" && (
        <div className="others-task">
          <div className="task-icons">
            {/*<FontAwesomeIcon
              icon={faSearch}
              className="icon"
              onClick={handleSearchClick}
              style={{ cursor: "pointer" }}
            />*/}
            <FontAwesomeIcon
              icon={faFile}
              className="icon"
              onClick={handleFileClick}
              style={{ cursor: "pointer" }}
            />
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>
          {invalidData?.map(
              (task, index) => (
                <OthersTaskCard key={index} task={task} />
              
            ))}          
        </div>
     )}
     
      <div className="task-nav">
        <div
          className={`tabButton ${
            selectedTab === "active-tab" ? "active" : ""
          }`}
          onClick={() => setSelectedTab("active-tab")}
        >
          Active
        </div>
        <div
          className={`tabButton ${
            selectedTab === "others-tab" ? "active" : ""
          }`}
          onClick={() => setSelectedTab("others-tab")}
        >
          Delayed
        </div>
      </div>      
    </div>
  );
};

export default RepairOrders;
